import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import BigNumber from 'bn.js'
import { useContext, useEffect, useState } from 'react'

import { CurrencyBalanceContext, CurrencyContext, GeotokensContext } from '../Contexts'
import { parseBigNumber } from '../parseBigNumber'
import { shiftBase10 } from '../shiftBase10'
import XyoTextField from './XyoTextField'

interface AllowanceDialogProps {
  onClose?: () => void
  open?: boolean
}

const AllowanceDialogOpen: React.FC<AllowanceDialogProps> = (props) => {
  const { onClose } = props
  const { geotokensAllowance = new BigNumber(0), balance, refresh } = useContext(CurrencyBalanceContext)
  const { erc20 } = useContext(CurrencyContext)
  const { geotokens } = useContext(GeotokensContext)
  const [amount, setAmount] = useState(shiftBase10(balance ?? new BigNumber(0), -18)?.toString(10))

  useEffect(() => {
    setAmount(shiftBase10(balance ?? new BigNumber(0), -18)?.toString(10) ?? '0')
  }, [balance])

  const onMaxClicked = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    setAmount(shiftBase10(balance, -18)?.toString() ?? '0')
  }

  const onClearClicked = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    setAmount('0')
  }

  const onApproveClicked = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    if (geotokens) {
      const total = shiftBase10(parseBigNumber(amount), 18) ?? new BigNumber(0)
      await erc20?.approve(geotokens.address(), total)
      refresh?.()
      onClose?.()
    } else {
      alert('No Minter Found')
    }
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAmount(event.target.value)
  }

  return (
    <Dialog
      onClose={() => {
        onClose?.()
      }}
      open={true}
    >
      <DialogTitle>Adjust Allowance</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column">
          <Box display="flex" width="100%">
            <Typography variant="body1">
              To deposit XYO tokens into a Geotoken, you need to approve the transfer for the Geotokens contract.
            </Typography>
          </Box>
          <Box padding={1}>
            <XyoTextField fullWidth label="Current" value={shiftBase10(geotokensAllowance, -18)?.toString() ?? ''} variant="outlined" />
          </Box>
          <Box padding={1}>
            <XyoTextField fullWidth label="New" onChange={onChange} value={amount ?? '0'} variant="outlined" />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" width="100%">
          <Box>
            <Button
              onClick={() => {
                props.onClose?.()
              }}
              variant="text"
            >
              Close
            </Button>
          </Box>
          <Box flexGrow={1}></Box>
          <Box>
            <Button onClick={onClearClicked} variant="text">
              Clear
            </Button>
            <Button onClick={onMaxClicked} variant="text">
              Max
            </Button>
            <Button onClick={onApproveClicked} variant="text">
              Approve
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

const GeotokensAllowanceDialog: React.FC<AllowanceDialogProps> = (props) => {
  const { open } = props
  if (open) {
    return <AllowanceDialogOpen {...props} />
  } else {
    return null
  }
}

export default GeotokensAllowanceDialog
